import { get } from 'lodash';

const root = state => get(state, 'ReportsState.transactionHistoryReports');

export const getDropdownItems = state => get(root(state), 'dropdownItems', []);
export const getLoadingDropdownItems = state =>
  get(root(state), 'loadingDropdownItems', false);
export const getLoadingDropdownItemsError = state =>
  get(root(state), 'loadingDropdownItemsError', null);
export const getSitesData = state => get(root(state), 'sitesData', []);
export const getLoadingSitesData = state =>
  get(root(state), 'loadingSitesData', false);
export const getLoadingSitesDataError = state =>
  get(root(state), 'loadingSitesDataError', null);
export const getEmptyPrintResponse = state =>
  get(root(state), 'emptyPrintResponse', null);
export const getLoadingPrint = state => get(root(state), 'loadingPrint', false);
export const getLoadingPrintError = state =>
  get(root(state), 'loadingPrintError', null);
export const getPrintData = state => get(root(state), 'printData', null);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/transactionhistoryreport/state/selectors.js